/* 
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import cloneDeep from 'lodash.clonedeep';
import {PlatformFileType} from '../types/entities';

/**
 * Helper function to return Platform ids for the available file permission features.
 */
export const getPlatFormIds = (Features, filePermissions) => {
  const filteredDeviceFileType = [];
  filePermissions?.forEach((item) => {
    const filePermissionIds = Features?.getFilePermissionsPlatformsIds?.(item);
    filteredDeviceFileType.push(...filePermissionIds);
  });
  return filteredDeviceFileType;
};

export const filterDeviceFileTypes = (platFormIds, deviceTypes) => {
  const _deviceTypes = cloneDeep(deviceTypes);
  return _deviceTypes?.filter((deviceType) => {
    deviceType.fileTypes = deviceType?.fileTypes
      ?.filter((fileType) => platFormIds?.indexOf(fileType?.platformId) > -1);
    return deviceType;
  })?.filter((item) => item.fileTypes.length !== 0);
};

/**
 * Helper function to return filtered device file types based on user file permissions.
 */
export const filterDeviceFileTypesByPermissions = (Features, filePermissions, deviceTypes) => {
  const filteredDeviceFileType = getPlatFormIds(Features, filePermissions);

  return filterDeviceFileTypes(filteredDeviceFileType, deviceTypes);
};

/**
 * Helper function to return filtered device file types based on selected devices platformIds.
 */
export const filterDeviceFileTypesByDevicesPlatformIds = (compatibleFileTypes, deviceTypes) => {
  const compatiblePlatformIds = getDevicePlatFormIds(compatibleFileTypes);
  
  return filterDeviceFileTypes(compatiblePlatformIds, deviceTypes);
};

export const getDevicePlatFormIds = (compatibleFileTypes, usePlatformName = false, isVbusIds = false) => {
  const comparator = ({platformName = '', platformId = ''}) => {
    if (!usePlatformName) {
      return isVbusIds ? platformId : `${platformId}`;
    }
    return platformName;
  };
  return compatibleFileTypes?.map(comparator)?.filter(platformId => platformId) || [];
};

const DM_UPDATE_DEVICES_FLAG = 'updateAssignedDevices';

/**
 * Determines if the given fileType (pre-defined on the platform) allows the dynamic
 * input field for showing the option to enable autojobs.
 * 
 * @param fileType the file type to check
 * @returns true if the file type allows autojobs, false otherwise
 */
export const fileTypeHasAutoJobs = (fileType: PlatformFileType): boolean => {
  const inputs = fileType?.inputFields;
  return !!inputs?.some(({name, showOnEdit}) => (
    name === DM_UPDATE_DEVICES_FLAG && showOnEdit
  ));
};
